import { jsx as _jsx } from "react/jsx-runtime";
import NOB from '../../../../constants/language-strings';
import { PASSED } from '../../constants';
import styled from 'styled-components';
import spacing from 'theme/spacing';
import { PurPurButton } from 'components';
const HealthCheckListButtonContainer = styled.div `
  text-align: center;
  margin-top: ${spacing.spacing24};
`;
const StyledButton = styled(PurPurButton) `
  width: 270px;
`;
export const UpdateHealthCheck = ({ healthCheck, updateHealthCheck, devicePollingCheckPassed, }) => {
    const passed = healthCheck.provisioning.allChecksPassed &&
        healthCheck.iccCheck.deviceLinks === PASSED &&
        healthCheck.iccCheck.devicePairing === PASSED &&
        devicePollingCheckPassed;
    return (_jsx(HealthCheckListButtonContainer, { children: _jsx(StyledButton, { size: "sm", type: "button", variant: passed ? "primary" : "destructive", onClick: updateHealthCheck, children: passed ? NOB.HEALTH_CHECK.BUTTON.UPDATE : NOB.HEALTH_CHECK.BUTTON.FIX_ERRORS }) }));
};
